import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams, useNavigate, NavLink, Link } from "react-router-dom";
import { Header } from "./components/Header";
import { ShimmerTable } from "react-shimmer-effects";
import toast, { Toaster } from "react-hot-toast";
import { type } from "@testing-library/user-event/dist/type";

const API_URL = "/api";

export default function TransactionSummary() {
  const { id } = useParams();
  console.log("🔎 Route id:", id);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [company, setCompany] = useState(null);
  const [transactionData, setTransactionData] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [checklistFormData, setChecklistFormData] = useState([]);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/getTransactionDetails/${id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        console.log("📥 Full API Response:", data);
        setTransactionData(data);
        console.log("transactionData:", transactionData);
        // setFormData(data?.DocumentCheckList || {});
        setFormData(data); // keep full object for Loan Info
        setCompany(data);
        console.log("Data:", data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanyDetails();
  }, []);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCancel = () => {
    setFormData(transactionData);
    setChecklistFormData(transactionData?.DocumentCheckList || []);
    setIsEditing(false);
  };

  const renderStatusCell = (section) => {
    let value = formData?.[section]?.STATUS || "";
    if (section === "ENTEREXPIRYDATE") value = "";
    return isEditing ? (
      <select
        className="form-select"
        value={value}
        onChange={(e) => handleChange(e, section, "STATUS")}
      >
        <option value="">Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
        <option value="N/A">N/A</option>
      </select>
    ) : (
      <div
        style={{
          backgroundColor: value === "Yes" ? "#58a65c" : "#fdf3d0",
          color: value === "Yes" ? "#fff" : "#000",
          textAlign: "center",
        }}
      >
        {value || ""}
      </div>
    );
  };

  const criteriaLabels = {
    COMPANYNAMEISCORRECT: "Company name is correct",
    THEREGISTRATIONISCURRENT: "The registration is current",
    THERETURNCOVERSTHEMOSTRECENTPERIOD:
      "The return covers the most recent period",
    SHAREHOLDER_SMATCHORGANIZATIONCHART_IFPROVIDED:
      "Shareholder(s) match organization chart (if provided)",
    THECHARTISSIGNEDANDDATED: "The chart is signed and dated",
    STATEMENTSARESIGNEDBYAUDITOR: "Statements are signed by auditor",
  };

  const renderCheckCell = (section) => {
    // if (section === "SUBMITTEDBUSINESSREGISTRATION") return "";

    // Show the label for these fields instead of CHECKINGDETAILS
    if (
      section === "COMPANYNAMEISCORRECT" ||
      section === "THEREGISTRATIONISCURRENT" ||
      section === "THERETURNCOVERSTHEMOSTRECENTPERIOD" ||
      section === "SHAREHOLDER_SMATCHORGANIZATIONCHART_IFPROVIDED" ||
      section === "THECHARTISSIGNEDANDDATED" ||
      section === "STATEMENTSARESIGNEDBYAUDITOR"
    ) {
      return criteriaLabels[section] || "";
    }

    if (section === "ENTEREXPIRYDATE") {
      const rawDate = formData?.ENTEREXPIRYDATE?.CHECKINGDETAILS;
      return rawDate ? formatDate(rawDate) : "";
    }

    return formData?.[section]?.CHECKINGDETAILS || "";
  };

  const handleInputChange = (sectionKey, field, value) => {
    setFormData((prev) => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        [field]: value,
      },
    }));
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    const { _id, ...rest } = formData;
    if (!_id) {
      alert("Missing _id");
      return;
    }
    // Remove any fields with undefined values
    const cleanedData = {};
    for (const key in rest) {
      if (rest[key] !== undefined) {
        cleanedData[key] = rest[key];
      }
    }
    const updatePayload = {
      _id: _id, // Make sure it's a string
      update_data: cleanedData,
    };

    try {
      const response = await fetch(
        "http://localhost:8000/riverchain/techop/v1.1/updateCompanyLog",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatePayload),
        }
      );

      const resultText = await response.text();

      if (!response.ok) {
        console.error("❌ Update failed:", resultText);
        alert("Update failed:\n" + resultText);
      } else {
        toast.success("Company log updated successfully");
      }
    } catch (error) {
      console.error("🚨 Network error:", error);
      toast.danger("An error occurred while updating the profile.");
    } finally {
      setIsSubmitting(false);
    }
  };
  // Utility: format date values into DD-MM-YYYY
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    if (isNaN(date)) return dateString; // fallback if invalid date
    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
  };
  const scoreMapping = {
    "Borrower: A": 20,
    "Borrower: B": 15,
    "Borrower: C": 0,
    "Borrower: D": -10,
  };
  const scoreMappingTransaction = {
    "0% to 10%": 0,
    "11% to 20%": 5,
    "21% to 30%": 8,
    "> 30%": 10,
  };
  const today = new Date();
  const formatted = today.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long", // 👈 gives full month name
    year: "numeric",
  });
  return (
    <div className="app-container">
      <Toaster />
      <div className="container-fluid">
        <main className="content">
          <Header />
        </main>
      </div>

      <div className="container">
        <div className="row mt-4">
          <div className="col-md-12">
            <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
              Back to Transaction List
            </NavLink>

            <br />
            <br />
            <NavLink
              to={`/ViewTransactionList/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Loan Details
            </NavLink>

            <NavLink
              to={`/Drawdowns/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Drawdowns
            </NavLink>

            <NavLink
              to={`/ApplicationChecklist/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Application Checklist
            </NavLink>

            <NavLink
              to={`/ScoreCard/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scorecard
            </NavLink>

            <NavLink
              to={`/TransactionSummary/${id}`}
              className="btn btn-dark ms-2"
            >
              Transaction Summary
            </NavLink>

            <NavLink
              to={`/TermSheet/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Term Sheet
            </NavLink>

            <NavLink
              to={`/Payments/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Payments
            </NavLink>

            <NavLink
              to={`/RepaymentAndInterest/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Repayment & Interest(Term)
            </NavLink>

            <NavLink
              to={`/ScoringCriteriaTf/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scoring Criteria
            </NavLink>

            <NavLink
              to={`/ScoringGuide/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Scoring Guide
            </NavLink>

            <NavLink
              to={`/InterestCalculations/${id}`}
              className="btn btn-outline-secondary ms-2"
            >
              Interest Calculations
            </NavLink>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <h3 style={{ marginTop: "15px" }}>Transaction Summary</h3>
              <div>
                {isEditing && (
                  <button
                    className="btn btn-secondary me-2 btn-sm"
                    onClick={handleCancel}
                  >
                    Cancel
                  </button>
                )}
                <button
                  className="btn btn-primary btn-sm"
                  onClick={async () => {
                    if (isEditing) {
                      setIsSubmitting(true);
                      await handleSubmit();
                      setIsSubmitting(false);
                    } else {
                      setFormData(transactionData);
                      setIsEditing(true);
                    }
                  }}
                  disabled={isSubmitting}
                >
                  {isEditing
                    ? isSubmitting
                      ? "Submitting..."
                      : "Submit"
                    : "Edit"}
                </button>
              </div>
            </div>

            {loading || !transactionData ? (
              <ShimmerTable row={5} col={5} />
            ) : (
              <>
                <div className="col-md-12">
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <td colSpan="2" style={{ color: "red" }}>
                          {formatted}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.TRANSACTIONID_LABEL ||
                            "Transaction ID"}
                        </td>
                        <td>{transactionData?.TRANSACTIONID || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>{transactionData?.BORROWER_LABEL || "Borrower"}</td>
                        <td>{transactionData?.BORROWER || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.BORROWERRATING_LABEL ||
                            "Borrower Ratting"}
                        </td>
                        <td>{transactionData?.BORROWERRATING || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.TRANSCATIONRATING_LABEL ||
                            "Transcation Rating"}
                        </td>
                        <td>{transactionData?.TRANSCATIONRATING || "N/A"}</td>
                      </tr>
                    </tbody>
                  </table>

                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th
                          colSpan="2"
                          style={{
                            backgroundColor: "#173660",
                            color: "white",
                            width: "40%",
                          }}
                        >
                          Proposed Transaction Terms
                        </th>
                        <th></th>
                        <th
                          colSpan="2"
                          style={{ backgroundColor: "#173660", color: "white" }}
                        >
                          Security
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {transactionData?.LOANAMOUNT_HK_LABEL ||
                            "Loan Amount(HK$)"}
                        </td>
                        <td>{transactionData?.LOANAMOUNT_HK || "N/A"}</td>
                        <td rowSpan="15"></td>
                        <td>
                          {transactionData?.SECURITYTYPE_LABEL ||
                            "Security Type"}
                        </td>
                        <td>{transactionData?.SECURITYTYPE || "N/A"}</td>
                      </tr>
                      <tr>
                        <td rowSpan="2">
                          {transactionData?.REPAYMENT_LABEL || "Repayment"}
                        </td>
                        <td rowSpan="2">
                          {transactionData?.REPAYMENT || "N/A"}
                        </td>
                        <td>{transactionData?.EMPLOYER_LABEL || "Employer"}</td>
                        <td>{transactionData?.EMPLOYER || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.MAINCONTRACTOR_LABEL ||
                            "Main Contractor"}
                        </td>
                        <td>{transactionData?.MAINCONTRACTOR || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>{transactionData?.TYPE_LABEL || "Type"}</td>
                        <td>{transactionData?.TYPE || "N/A"}</td>
                        <td>{transactionData?.PROJECT_LABEL || "Project"}</td>
                        <td>{transactionData?.PROJECT || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.MAXTERM_MONTHS_LABEL ||
                            "Max Term Month"}
                        </td>
                        <td>{transactionData?.MAXTERM_MONTHS || "N/A"}</td>
                        <td>{transactionData?.TYPE1_LABEL || "Type"}</td>
                        <td>{transactionData?.TYPE1 || "N/A"}</td>
                      </tr>
                      <tr>
                        <td rowSpan="2">
                          {transactionData?.PROPOSED_TRANS_TERM
                            ?.REPAYMENT_PERCENTAGE__IFREVENUE_BASED_LABEL ||
                            "Repayment % (if revenue-based)"}
                        </td>
                        <td rowSpan="2">
                          {transactionData?.PROPOSED_TRANS_TERM
                            ?.REPAYMENT_PERCENTAGE__IFREVENUE_BASED || "N/A"}
                        </td>
                        <td>
                          {transactionData?.PROJECTSTATUS_LABEL ||
                            "Project Status"}
                        </td>
                        <td>{transactionData?.PROJECTSTATUS || "N/A"}</td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.SECURITY?.PROJECTVALUE_HK_LABEL ||
                            "Project Value(HK$)"}
                        </td>
                        <td>
                          {transactionData?.SECURITY?.PROJECTVALUE_HK != null
                            ? transactionData.SECURITY.PROJECTVALUE_HK
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.INTERESTRATE_LABEL ||
                            "Interest Rate"}
                        </td>
                        <td>
                          {transactionData?.INTERESTRATE != null
                            ? (transactionData.INTERESTRATE * 100).toFixed(2) +
                              "%"
                            : "N/A"}
                        </td>
                        <td>
                          {transactionData?.SECURITY?.CERTIFIEDTODATE_LABEL ||
                            "Certificate To Date"}
                        </td>
                        <td>
                          {transactionData?.SECURITY?.CERTIFIEDTODATE != null
                            ? transactionData.SECURITY.CERTIFIEDTODATE
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.ADMINFEE_LABEL || "Admin Fee"}
                        </td>
                        <td>
                          {transactionData?.ADMINFEE != null
                            ? (transactionData.ADMINFEE * 100).toFixed(2) + "%"
                            : "N/A"}
                        </td>
                        <td rowSpan="2">
                          {transactionData?.SECURITY
                            ?.PERCENTAGE_COMPLETED_LABEL || "% Completed"}
                        </td>
                        <td rowSpan="2">
                          {transactionData?.SECURITY?.[
                            "_PERCENTAGE_COMPLETED"
                          ] ?? "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            {transactionData?.TOTALEXPECTEDREVENUE_HK_LABEL ||
                              "Total Expected Revenue(HK$)"}
                          </strong>
                        </td>
                        <td>
                          {transactionData?.TOTALEXPECTEDREVENUE_HK || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ paddingLeft: "40px" }}>
                          {transactionData?.TOTALFEES_HK_LABEL ||
                            "Total Fees(HK$)"}
                        </td>
                        <td>{transactionData?.TOTALFEES_HK || "N/A"}</td>
                        <td>
                          {transactionData?.SECURITY?.MONTHSOFLOWLOAN_LABEL ||
                            "Months of low Loan/NEP/term"}
                        </td>
                        <td>
                          {transactionData?.SECURITY?.[
                            "MONTHSOFLOWLOAN/NEP/TERM"
                          ] ?? "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ paddingLeft: "40px" }} rowSpan="2">
                          {transactionData?.TOTALINTEREST_HK_LABEL ||
                            "Total Interest(HK$)"}
                        </td>
                        <td rowSpan="2">
                          {transactionData?.TOTALINTEREST_HK || "N/A"}
                        </td>
                        <td>
                          {transactionData?.SECURITY
                            ?.EXPECTEDREPAYMENTS_LABEL ||
                            "#Expected Repayments"}
                        </td>
                        <td>
                          {transactionData?.SECURITY?.["#EXPECTEDREPAYMENTS"] ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.LOANTOCONTRACTVALUE ||
                            "Loan Contract Value"}
                        </td>
                        <td>{transactionData?.LOANTOCONTRACTVALUE || "N/A"}</td>
                      </tr>
                      <tr>
                        <td rowSpan="2">
                          <strong>
                            {transactionData?.EXPECTEDLOANRETURN_LABEL ||
                              "Expected Loan Return"}
                          </strong>
                        </td>
                        <td rowSpan="2">
                          {transactionData?.EXPECTEDLOANRETURN != null
                            ? (
                                transactionData.EXPECTEDLOANRETURN * 100
                              ).toFixed(2) + "%"
                            : "N/A"}
                        </td>
                        <td>
                          {transactionData?.SECURITY?.TARGETLOAN_NEP_LABEL ||
                            "Target Loan/NEP"}
                        </td>
                        <td>
                          {transactionData?.SECURITY?.["TARGETLOAN/NEP"] != null
                            ? (
                                transactionData.SECURITY["TARGETLOAN/NEP"] * 100
                              ).toFixed(2) + "%"
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          {transactionData?.CONTRACT_SECURITY_ANALYSIS_VALUES
                            ?.LOANTOCONTRACTVALUE ||
                            "Months of Low Loan/ Next Expected Payment"}
                        </td>
                        <td>
                          {transactionData?.CONTRACT_SECURITY_ANALYSIS_VALUES?.[
                            "MONTHSOFLOWLOAN/NEXTEXPECTEDPAYMENT"
                          ] ?? "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th
                          style={{
                            backgroundColor: "#173660",
                            color: "white",
                            width: "50%",
                          }}
                        >
                          Key Risks
                        </th>
                        <th></th>
                        <th
                          style={{
                            backgroundColor: "#173660",
                            color: "white",
                            width: "50%",
                          }}
                        >
                          Suggested Mitigants
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {isEditing ? (
                            <input
                              type="text"
                              value={
                                formData?.highRiskReason ||
                                "High-risk Borrower [provide details why]"
                              }
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  highRiskReason: e.target.value,
                                })
                              }
                            />
                          ) : (
                            formData?.highRiskReason ||
                            "High-risk Borrower [provide details why]"
                          )}
                        </td>
                        <td></td>
                        <td>
                          {isEditing ? (
                            <input
                              type="text"
                              value={formData.collectionAccount}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  collectionAccount: e.target.value,
                                })
                              }
                              placeholder="Riverchain collection account"
                            />
                          ) : (
                            formData.collectionAccount ||
                            "Riverchain collection account"
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
